const state = {
  // 核酸检测详情
  storeNucleicacidRecordDetail: (
      sessionStorage.getItem("storeNucleicacidRecordDetail") &&
      JSON.parse(sessionStorage.getItem("storeNucleicacidRecordDetail"))
    ) || null
}

const mutations = {
  // 设置
  setNucleicacidRecordDetail(state, payload) {
    state['storeNucleicacidRecordDetail'] = payload
    sessionStorage.setItem("storeNucleicacidRecordDetail", JSON.stringify(payload))
  },
  // 清除
  removeNucleicacidRecordDetail(state){
    state['storeNucleicacidRecordDetail'] = null
    sessionStorage.removeItem("storeNucleicacidRecordDetail")
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/nucleicacid.js